<template>
  <!-- 注意 该组件会额外为组件套一层 影响页面布局 -->
  <div class="lazy-component" ref="observeTarget" v-loading="!visible">
    <div v-if="visible">
      <slot></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: "LazyComponent",
  props: {
    // 触发加载的阈值（0-1之间）
    threshold: {
      type: Number,
      default: 0.1
    },
    // 视口边距偏移
    rootMargin: {
      type: String,
      default: "0px"
    }
  },
  data() {
    return {
      visible: false,
      observer: null
    };
  },
  mounted() {
    // 创建 Intersection Observer
    this.observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          this.visible = true;
          // 停止观察以避免重复触发
          this.observer.unobserve(entry.target);
        }
      },
      {
        threshold: this.threshold,
        rootMargin: this.rootMargin
      }
    );

    // 开始观察目标元素
    if (this.$refs.observeTarget) {
      this.observer.observe(this.$refs.observeTarget);
    }
  },
  beforeDestroy() {
    // 清理 observer 避免内存泄漏
    if (this.observer) {
      this.observer.disconnect();
    }
  }
};
</script>

<style scoped lang="scss">
.lazy-component {
  min-height: 200px;
}
</style>
